angular.module('invoice')
    .factory('InvoiceCostType', function ($resource) {
        return $resource('/crm/api/invoice-cost-type/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/invoice-cost-type/autocomplete'}
        })
    })
    .service('InvoiceCostTypeService', function ($rootScope, toastr, modals, InvoiceCostType) {
        this.edit = id => {
            return InvoiceCostType.get({id: id}, entity => editModal(entity))
        }
        this.addModal = () => {
            let entity = {
                id: null
            }
            return editModal(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => InvoiceCostType.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('invoice-cost-type.updated')))
        }

        function editModal(entity) {
            return modals.open('app/invoice/cost-type/edit-modal.html', 'InvoiceCostTypeDialogController', entity, {size: "sm"}, "$ctrl")
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceCostTypeList', {
            parent: 'app',
            url: '/settings/invoice-cost-type?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_INVOICE_SETTINGS_READ']
            },
            views: {
                'content@': 'invoiceCostTypeList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (InvoiceCostType, $stateParams) => InvoiceCostType.list(angular.copy($stateParams)).$promise
            }
        })
    })
